export default {
  topBar: {
    device: {
      deviceRotate: '设备分辨率',
      select: '请选择',
    },
    playScene: {
      play: '播放场景',
      pause: '回到初始状态',
    },
  },
  takeColor: {
    bindEventMessage: '游戏未加载完毕',
  },
  bottomBar: {
    scaleManager: {
      validateTips: '缩放值应在50-200之间',
    },
    estimateSize: {
      packageEstimate: '包体预估',
      packageEstimating: '包体预估中',
      packageEstimateTip: '制作过程中请及时查看包体大小，避免包体超包',
      high: '高质量',
      middle: '中质量',
      low: '低质量',
      packageLimitTip: '包体限制',
    },
  },
  device: {
    orientationList: {
      horizontal: '横屏',
      portrait: '竖屏',
    },
    adaptToTheScreen: '适应屏幕',
  },
}
